enum FormField {
	Company = 'company',
	Email = 'contactEmail',
	Firstname = 'firstname',
	Message = 'message',
	Subject = 'subject',
	Phone = 'phone',
	Position = 'position',
	Surname = 'surname',
	Contact = 'contact',
	Documents = 'documents',
	CreateDeal = 'createDeal',
}

export { FormField };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Share/UprezForm/typings.ts